import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M9 4l4 4-4 4m2.5-4h-9", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
